import { Component, Input, OnInit, ViewChild, ViewEncapsulation, OnDestroy, OnChanges, SimpleChanges, ChangeDetectorRef, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ILLEstablishment, ILLFormDetail, ILLGenericKeys, ILLRelationship, ICompanyDetail, ILLCompany, ILLCustomerCompaniesByTypeWrapper } from '../../../../shared/models';
import { LLFormService, CompanyContactService, StorageManagerService } from '../../../../shared/services';
import { EstablishmentModalComponent } from '../establishment-modal/establishment-modal.component';
import { Subscription, Observable, forkJoin, of } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { RefdataService } from '../../../../shared/services/refdata.service';
import { catchError } from 'rxjs/operators';
import { CompanyDetailsComponent } from '../../../index';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';

@Component({
    selector: 'app-ll-form-establishment',
    templateUrl: './ll-form-establishment.component.html',
    styleUrls: ['./ll-form-establishment.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LLFormEstablishmentComponent implements OnInit, OnDestroy, OnChanges {

    establishmentSectionForm: UntypedFormGroup;
    sub: Subscription;
    labelerForm: any;
    productInfoForm: any;
    ndcProductCOde: string;

    @Input() llFormData: any;
    @Input() changedNdcCode: any;
    @Input() ndcLabelerCode: any;
    @Input() prodIndex: number;
    @Input() bDeleteProduct: boolean;
    @Input() canCreateCompany: boolean;

    @Output() labelerCodeOutput = new EventEmitter<any>();

    @ViewChild('establishmentModal') establishmentModal: EstablishmentModalComponent;
    @ViewChild('companyDialog') public companyDialog: DialogComponent;
    @ViewChild('companyDetails') public companyDetailsComponent: CompanyDetailsComponent;

    estabCompanyEdited: ILLEstablishment;
    newNdcProductCode: any;
    oldNdcProductCode: any;
    labelerCode: any;
    estabCompanies: ILLCompany[] = [];
    iconTypeCompany = true;
    hidden: Boolean = false;
    allEstablishmentCompanies: ILLEstablishment[] = [];
    company$: Observable<ICompanyDetail> | null;
    companyToViewRevisionId: number;
    parentComponent: any;
    customerGuid: string;
    companyData: any;
    animationSettings: Object = { effect: 'Zoom' };

    constructor (private fb: UntypedFormBuilder, private llFormService: LLFormService, private cdRef: ChangeDetectorRef, private toastr: ToastrService, private companyService: CompanyContactService, private refDataService: RefdataService, private storageManagerService: StorageManagerService) { }

    ngOnChanges(changes: SimpleChanges) {

        const formArray = new UntypedFormArray([]);

        // eslint-disable-next-line guard-for-in
        for (const property in changes) {

            if (property === 'ndcLabelerCode' && changes[property].currentValue) {

                if (this.llFormData[0].data.establishments && this.llFormData[0].data.establishments.length > 0) {

                    this.llFormData[0].data.establishments.forEach((estab, e) => {

                        estab.businessOperations.forEach((bo, b) => {

                            bo.ndcProductCode.forEach((prod, p) => {

                                if (prod) {
                                    const newCode = `${ this.ndcLabelerCode }-${ prod.split('-')[1] }`;

                                    this.llFormData[0].data.establishments[e].businessOperations[b].ndcProductCode[p] = newCode;
                                }
                            });
                        });

                        formArray.push(this.fb.group({
                          companyRevisionId: estab.establishmentCompany.companyRevisionId,
                          companyName: estab.establishmentCompany.companyName,
                          duns: estab.establishmentCompany.dunsNumber,
                            busOps: this.flattenBusOps(estab.businessOperations)
                        }));
                    });
                    if (this.establishmentSectionForm) {
                        this.establishmentSectionForm.setControl('estabCompanyFormArray', formArray);
                    }
                }
            }

            if (property === 'changedNdcCode' && changes[property].currentValue) {

                this.oldNdcProductCode = changes[property].currentValue.split('|')[0];
                this.newNdcProductCode = changes[property].currentValue.split('|')[1];

                this.modifyExistingEstablishments(this.llFormData[0].data);
            }
        }

    }

    modifyExistingEstablishments(llForm: ILLFormDetail) {

        const formArray = new UntypedFormArray([]);
        const establishmentsArray: ILLEstablishment[] = llForm.establishments;

        if (establishmentsArray && establishmentsArray.length > 0) {

            establishmentsArray.forEach((estab, e) => {

                estab.businessOperations.forEach((bo, b) => {

                    bo.ndcProductCode.forEach((prod, p) => {

                        const productToReplace = bo.ndcProductCode.find(pr => pr.split('-')[1] === this.oldNdcProductCode);

                        if (productToReplace) {
                            const newCode = `${ prod.split('-')[0] }-${ this.newNdcProductCode }`;

                            const deletedProductIndex = bo.ndcProductCode.findIndex(x => x === productToReplace);

                            this.llFormData[0].data.establishments[e].businessOperations[b].ndcProductCode.splice(deletedProductIndex, 1);

                            this.llFormData[0].data.establishments[e].businessOperations[b].ndcProductCode.push(newCode);
                        }
                    });
                });

                formArray.push(this.fb.group({
                  companyRevisionId: estab.establishmentCompany.companyRevisionId,
                  companyName: estab.establishmentCompany.companyName,
                  duns: estab.establishmentCompany.dunsNumber,
                    busOps: this.flattenBusOps(estab.businessOperations)
                }));
            });

            if (this.establishmentSectionForm) {
                this.establishmentSectionForm.setControl('estabCompanyFormArray', formArray);
            }
        }
    }

    ngOnInit() {

        this.getEstabCompanies();

        this.initializeForm();

        this.patchForm();

        this.checkLabelerMismatch();
    }

    checkLabelerMismatch() {

        this.sub = this.llFormService.llFormProductLabelerCodeSubject.subscribe(data => {

            if(data){
                const productProductCode = data;
                const productLabelerCode = productProductCode ? productProductCode.split('-')[0] : '';

                // if product level labeler code is different, take the product level labeler.
                if (this.ndcLabelerCode !== productLabelerCode) {
                    this.labelerCodeOutput.emit(productLabelerCode);
                }
            }

        });
    }

    getEstabCompanies() {

        if (this.llFormData && this.llFormData[2].data) {

            const companyTypes: ILLCustomerCompaniesByTypeWrapper = this.llFormData[2].data;

            // unique companies
            this.allEstablishmentCompanies = this.getAllEstablishmentCompanies(companyTypes).sort(this.compare);
        }
    }

    initializeForm() {

        this.establishmentSectionForm = this.fb.group({
            estabCompanyFormArray: this.fb.array([this.addEstabCompanyForm()])
        });
        this.parentComponent = this;

        const currentCustomerStr: string = this.storageManagerService.read('currentCustomer');


        if (currentCustomerStr) {
            const currentCustomer = JSON.parse(currentCustomerStr);
            if (currentCustomer) {
                this.customerGuid = currentCustomer.customerGuid;
            }
        }
    }

    addEstabCompanyForm(): UntypedFormGroup {

        return this.fb.group({
            companyRevisionId: [0],
            companyName: ['', { validators: [] }],
            duns: ['', { validators: [] }],
            busOps: ['', { validators: [] }]
        });
    }


    get estabCompanyFormArray(): UntypedFormArray {
        return <UntypedFormArray>this.establishmentSectionForm.get('estabCompanyFormArray');
    }

    patchForm() {

        this.establishmentSectionForm.reset();

        this.establishmentSectionForm.setControl('estabCompanyFormArray', this.setEstabCompanyForm());

        this.cdRef.detectChanges();
    }

    setEstabCompanyForm(): UntypedFormArray {

        const formArray = new UntypedFormArray([]);
        let establishmentsArray: ILLEstablishment[] = [];

        if (this.llFormData) {

            if (this.llFormData[0] && this.llFormData[0].data) {

                const llForm: ILLFormDetail = this.llFormData[0].data;

                establishmentsArray = llForm.establishments;

                if (establishmentsArray && establishmentsArray.length > 0) {

                    establishmentsArray.forEach(element => {

                        formArray.push(this.fb.group({
                          companyRevisionId: element.establishmentCompany.companyRevisionId,
                          companyName: element.establishmentCompany.companyName,
                          duns: element.establishmentCompany.dunsNumber,
                            busOps: this.flattenBusOps(element.businessOperations)
                        })
                        );

                    });
                }
            }
        }


        this.establishmentSectionForm.markAsPristine();
        return formArray;
    }

  flattenBusOps(busOps: ILLRelationship[]): any {

    let bo: ILLGenericKeys;
    let boString = '';
    let selectedBoCounter = 0;

    if (busOps && busOps.length > 0) {

      busOps.forEach((element, i) => {

        bo = element.selected ? element.businessOperations : undefined;

        if (!!bo) {

          const ndcProductCodes = this.getUniqueNdcProductCodes(element.ndcProductCode);

          if (ndcProductCodes.length > 0) {

            boString += `${ selectedBoCounter > 0 ? ', ' : '' } ${ bo.label }`;

            if (ndcProductCodes[0]) {
              boString += ` (${ ndcProductCodes.map(code => `${ code }`) })`;
            }

          } else {
            boString += `${ selectedBoCounter > 0 ? ', ' : '' } ${ bo.label }(${ bo.code })`;
          }
          selectedBoCounter++;
        }
      });
    }

    return boString;
  }

  getUniqueNdcProductCodes(ndcProductCodes: string[]): string[] {

    const uniqueProductCodes: string[] = [];

    if (ndcProductCodes && ndcProductCodes.length > 0) {
      ndcProductCodes.forEach(code => {
        const splitCodes = code ? code.toString().split(',') : [];

        splitCodes.forEach(splitCode => {
          const trimmedCode = splitCode ? splitCode.trim() : '';

          if (trimmedCode && uniqueProductCodes.indexOf(trimmedCode) === -1) {
            uniqueProductCodes.push(trimmedCode);
          }
        });
      });
    }

    return uniqueProductCodes;
  }


  estabModalOpen(event) {

        this.establishmentModal.warningModalText = '';

        this.sub = this.llFormService.llFormProductInformationSubject.subscribe(pi => {
            this.productInfoForm = pi;
        });

        if (this.llFormData[0] && this.llFormData[0].data) {

            // set entered data on the current product
            this.llFormData[0].data.products[this.prodIndex].ndcProductCode = `${ this.productInfoForm.labelerCode }-${ this.productInfoForm.itemCode }`;

            // === 'null' is taken care in DB, no 'null' anymore but just in case.
            if (this.llFormData[0].data.products && this.llFormData[0].data.products.length > 0) {

                const missingCodesArray = this.llFormData[0].data.products.filter(prod => !prod.ndcProductCode.split('-')[0] || prod.ndcProductCode.split('-')[0] === 'null' || prod.ndcProductCode.split('-')[0] === null ||
                    !prod.ndcProductCode.split('-')[1] || prod.ndcProductCode.split('-')[1] === 'null' || prod.ndcProductCode.split('-')[1] === null
                    || prod.ndcProductCode.split('-')[1] === 'xxxx');

                if (missingCodesArray && missingCodesArray.length > 0) {
                    this.establishmentModal.warningModalText += `Establishments cannot be created due to missing NdcProductCode or NdcLabelerCode in `;

                    this.llFormData[0].data.products.forEach((prod, i) => {

                        if (!prod.ndcProductCode.split('-')[0] || prod.ndcProductCode.split('-')[0] === 'null' || prod.ndcProductCode.split('-')[0] === null ||
                            !prod.ndcProductCode.split('-')[1] || prod.ndcProductCode.split('-')[1] === 'null' || prod.ndcProductCode.split('-')[1] === null
                        || prod.ndcProductCode.split('-')[1] === 'xxxx') {

                            this.establishmentModal.warningModalText += `Product ${ i + 1 }${ i < this.llFormData[0].data.products.length - 1 ? ', ' : '' }`;
                        }
                    });
                  this.establishmentModal.pageLoaded = false;
                    this.establishmentModal.modalDialog.show();
                } else {
                  this.establishmentModal.pageLoaded = false;
                    this.establishmentModal.visible = true;
                    this.establishmentModal.dialog.show();
                }
            }
        }


        this.establishmentSectionForm.markAsDirty();
    }


  saveModalForm(data) {

      // holding data for saving the ll form
      if (!data.cancel) {
        this.llFormService.llFormEstablishmentSubject.next(data.estabForm);
      }

    this.establishmentSectionForm.reset();

    if (data.cancel) {
      this.llFormData[0].data = data.originalFormData;
      this.establishmentSectionForm.setControl('estabCompanyFormArray', this.setEstabCompanyForm());
    } else {

      this.setEstabCompanyFormEdited(data.estabForm);
    }

      this.establishmentSectionForm.markAsDirty();
    }

  setEstabCompanyFormEdited(data) {

    const formArray = new UntypedFormArray([]);
    let estabCompanyEdited: ILLEstablishment;
    let boProducts: any[] = [];

    if (this.llFormData) {
      if (this.llFormData[0] && this.llFormData[0].data) {

        const llForm: ILLFormDetail = this.llFormData[0].data;

        // check selected busOps and products.
        if (data && data.companies && data.companies.length > 0) {

          this.llFormData[0].data.establishments = [];
          const modalCompanies = Array.from(data.companies);

          modalCompanies.forEach(establishmentModal => {

            const flatBusOps: any[] = [];

            if (this.llFormData[2].data) {

              this.allEstablishmentCompanies = this.getAllEstablishmentCompanies(this.llFormData[2].data);

              estabCompanyEdited = this.getMatchingEstablishmentCompany(establishmentModal);
            }

            if (estabCompanyEdited) {

              estabCompanyEdited.confidentiality = establishmentModal['confidential'] ? establishmentModal['confidential'] : false;

              const businessOperations = Array.from(establishmentModal['busOps']);

              if (businessOperations && businessOperations.length > 0) {

                estabCompanyEdited.businessOperations = [];

                // get only selected ndcProductCodes
                businessOperations.forEach((bp, i) => {

                  boProducts = Array.from(bp['products']).filter(p => p['selected'] === true);

                  const uniqueNdcCodes = boProducts.map(item => item['ndcProductCode'])
                    .filter((value, index, self) => self.indexOf(value) === index);

                  estabCompanyEdited.businessOperations[i] = new ILLRelationship();

                  estabCompanyEdited.businessOperations[i].selected = bp['selected'];
                  estabCompanyEdited.businessOperations[i].businessOperationsCompanyRevisionId = bp['businessOperationsCompanyRevisionId'];
                  estabCompanyEdited.businessOperations[i].ndcProductCode = uniqueNdcCodes;

                  estabCompanyEdited.businessOperations[i].businessOperations = new ILLGenericKeys();

                  estabCompanyEdited.businessOperations[i].businessOperations.code = bp['busOpCode'];
                  estabCompanyEdited.businessOperations[i].businessOperations.id = bp['busOpId'];
                  estabCompanyEdited.businessOperations[i].businessOperations.label = bp['busOpLabel'];


                  flatBusOps.push(bp);
                });

                formArray.push(this.fb.group({
                  companyRevisionId: estabCompanyEdited.establishmentCompany.companyRevisionId,
                  companyName: estabCompanyEdited.establishmentCompany.companyName,
                  duns: estabCompanyEdited.establishmentCompany.dunsNumber,
                  busOps: this.flattenBusOpsEdited(flatBusOps)
                }));

                this.llFormData[0].data.establishments.push(estabCompanyEdited);

              }
            } else {

              this.toastr.error('The company was added but name not selected from the list.');
            }
          });

        } else {

          // modal being saved without any establishment companies
          this.llFormData[0].data.establishments = [];
        }
      }
      this.establishmentSectionForm.setControl('estabCompanyFormArray', formArray);
    }
  }

    flattenBusOpsEdited(busOps: any[]): any {

        let boString = '';
        let selectedBoCounter = 0;

        if (busOps && busOps.length > 0) {

            busOps.forEach((bo, i) => {

                if (bo && bo.selected) {

                    const selectedProducts = bo.products.filter(p => p['selected'] === true);

                    if (selectedProducts.length > 0) {

                        boString += `${ selectedBoCounter > 0 ? ', ' : '' } ${ bo.busOpLabel } (${ bo.busOpCode }) (${ selectedProducts.map(code => `${ code['ndcProductCode'] }`) }) `;

                        selectedBoCounter++;
                    } else {

                        boString += `${ selectedBoCounter > 0 ? ', ' : '' } ${ bo.busOpLabel } (${ bo.busOpCode })`;

                        selectedBoCounter++;
                    }
                }
            });
        }

        return boString;
    }

    // Check if the previously saved company is the latest version
    isCompanyLatest(companyRevisionId: number) {

        if (companyRevisionId) {
          const company = this.allEstablishmentCompanies.find(x => this.companyRevisionIdsMatch(x.establishmentCompany.companyRevisionId, companyRevisionId));

            if (!company) {
                return false;
            }
        }

        return true;
    }

    companyRevisionIdsMatch(firstId: any, secondId: any): boolean {
      return firstId !== undefined && firstId !== null
        && secondId !== undefined && secondId !== null
        && firstId.toString() === secondId.toString();
    }

    normalizeDunsNumber(value: any): string {
      return value ? value.toString().replace(/\D/g, '') : '';
    }

    normalizeCompanyName(value: any): string {
      return value
        ? value.toString().replace(/^\(\s*\d+\s*\)\s*/, '').trim().replace(/\s+/g, ' ').toLowerCase()
        : '';
    }

    getCompanyDunsNumber(establishment: ILLEstablishment): string {
      const company = establishment ? establishment.establishmentCompany : null;

      if (!company) {
        return '';
      }

      const dunsNumber = this.normalizeDunsNumber(company.dunsNumber);

      if (dunsNumber) {
        return dunsNumber;
      }

      const companyNameMatch = company.companyName ? company.companyName.toString().match(/^\(\s*(\d+)\s*\)/) : null;

      return companyNameMatch ? this.normalizeDunsNumber(companyNameMatch[1]) : '';
    }

    getMatchingEstablishmentCompany(establishmentModal: any): ILLEstablishment {
      const companyRevisionId = establishmentModal ? establishmentModal['companyRevisionId'] : null;
      const dunsNumber = this.normalizeDunsNumber(establishmentModal ? (establishmentModal['dunsNumber'] || establishmentModal['duns']) : '');
      const companyName = this.normalizeCompanyName(establishmentModal ? establishmentModal['companyName'] : '');
      const establishmentCompanies = this.getSaveEstablishmentCompanies();
      const matchingCompanyRevision = establishmentCompanies
        .find(t => this.companyRevisionIdsMatch(t.establishmentCompany.companyRevisionId, companyRevisionId));

      if (matchingCompanyRevision) {
        return matchingCompanyRevision;
      }

      if (dunsNumber) {
        const matchingDunsNumber = establishmentCompanies
          .find(t => this.getCompanyDunsNumber(t) === dunsNumber);

        if (matchingDunsNumber) {
          return matchingDunsNumber;
        }
      }

      if (companyName) {
        return establishmentCompanies
          .find(t => this.normalizeCompanyName(t.establishmentCompany.companyName) === companyName);
      }

      return null;
    }

    getSaveEstablishmentCompanies(): ILLEstablishment[] {
      const currentEstablishments = this.llFormData && this.llFormData[0] && this.llFormData[0].data && this.llFormData[0].data.establishments
        ? this.llFormData[0].data.establishments
        : [];

      return this.getUniqueEstablishments((this.allEstablishmentCompanies || []).concat(currentEstablishments || []));
    }

    getUniqueEstablishments(establishments: ILLEstablishment[]): ILLEstablishment[] {
      const uniqueEstablishments: ILLEstablishment[] = [];

      (establishments || []).forEach(establishment => {
        if (!establishment || !establishment.establishmentCompany) {
          return;
        }

        const existingEstablishment = uniqueEstablishments.find(unique => this.companyRevisionIdsMatch(
          unique.establishmentCompany.companyRevisionId,
          establishment.establishmentCompany.companyRevisionId
        ));

        if (!existingEstablishment) {
          uniqueEstablishments.push(establishment);
        }
      });

      return uniqueEstablishments;
    }

    getAllEstablishmentCompanies(companyTypes: ILLCustomerCompaniesByTypeWrapper): ILLEstablishment[] {
      return Array.from(new Set(
        (companyTypes.establishments || [])
          .concat(companyTypes.establishmentsThirdParty || [])
          .concat(companyTypes.establishmentOwnedAndEstablishmentThirdParty || [])
      ));
    }

    compare(a, b) {
      if (a.establishmentCompany.companyName < b.establishmentCompany.companyName) {
            return -1;
        }
      if (a.establishmentCompany.companyName > b.establishmentCompany.companyName) {
            return 1;
        }
        return 0;
    }

    ngOnDestroy(): void {

        if (this.sub) {
            this.sub.unsubscribe();
        }
    }

    showCompanyDialog(companyRevisionId?: number) {

        this.establishmentSectionForm.markAsDirty();
        // this.pageLoading = true;

        if (companyRevisionId) {

            const companyData$ = forkJoin([this.companyService.getBusinessCategories(false),
            this.companyService.getCountries(),
            this.companyService.getContacts(),
            this.refDataService.GetAllBusinessOperationQualifier(),
            this.companyService.getCompanyRevisionHistory(companyRevisionId),
            this.companyService.getBusinessOperationQualifierByCompany(companyRevisionId.toString()),
            this.companyService.getCompanyById(companyRevisionId.toString()),
            this.companyService.getNDCLabelerCodesByCompany(companyRevisionId.toString())]
            ).pipe(catchError(err => of(err)
            )).subscribe(data => {

                if (this.companyDetailsComponent) {

                    this.companyDetailsComponent.companyData = data;
                    this.companyDetailsComponent.companyRevisionId = companyRevisionId.toString();
                    this.companyDetailsComponent.populateDataFromResolver();
                    this.companyDetailsComponent.setButtons();
                    this.companyDetailsComponent.getFormControlByName('status').patchValue('Active');
                    this.companyDetailsComponent.checkUserPermission();
                    this.companyDetailsComponent.ngAfterViewInit();
                }

                // this.pageLoading = false;
                this.companyDialog.show();
            },
              error => {
                this.toastr.error(error && error.errorMessage ? error.errorMessage : error);
            });
        } else {
            const companyData = [];

            this.sub = this.companyService.getBusinessCategories(false).subscribe(busCat => {
                companyData[0] = busCat;

                this.sub = this.companyService.getCountries().subscribe(countries => {
                    companyData[1] = countries;

                    this.sub = this.companyService.getContacts().subscribe(contacts => {
                        companyData[2] = contacts;

                        this.refDataService.GetAllBusinessOperationQualifier().subscribe(busQual => {

                            companyData[3] = busQual;

                            if (this.companyDetailsComponent) {

                                this.companyDetailsComponent.companyData = companyData;
                                this.companyDetailsComponent.companyRevisionId = '';
                                this.companyDetailsComponent.company = null;
                                this.companyDetailsComponent.companyHistory_grid_data = [];
                                this.companyDetailsComponent.populateDataFromResolver();
                                this.companyDetailsComponent.setButtons();
                                this.companyDetailsComponent.checkUserPermission();
                                this.companyDetailsComponent.ngAfterViewInit();
                            }

                            // this.pageLoading = false;
                            this.companyDialog.show();

                        });
                    });
                });
            },
              error => {
                this.toastr.error(error && error.errorMessage ? error.errorMessage : error);
              });
        }
    }

    modalCompany(newCompany) {

        this.setSavedEstCompany(newCompany.companyRevisionId);

        this.companyDialogCancelButtonClicked();
    }


    setSavedEstCompany(companyRevisionId: any) {

        this.sub = this.llFormService.getLCompanyTypesByCustomerGuid(this.customerGuid).subscribe(response => {

            const companyTypes = response['data'];

            this.llFormData[2].data = companyTypes;

            this.cdRef.detectChanges();
        },
          error => {
            this.toastr.error(error && error.errorMessage ? error.errorMessage : error);
          });

        this.establishmentSectionForm.markAsDirty();
    }

    companyDialogCancelButtonClicked() {

        if (this.companyDetailsComponent) {

            this.companyDetailsComponent.companyForm.clearValidators();
        }
        this.companyDialog.hide();
    }

    compareName(a, b) {
        if (a.name < b.name) {
            return -1;
        }
        if (a.name > b.bame) {
            return 1;
        }
        return 0;
    }


}
